export default "__VITE_ASSET__C9_wAm6V__"